import React from 'react';
import axios from 'axios';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import StatusRadioGroup from 'components/StatusRadioGroup';
import moment from 'components/momentWithZone';
import StandardSteps from 'components/StandardSteps';
import apiPath from 'apiPath';
import stickyError from 'components/stickyError';
import { Card, Input, Form, DatePicker, Button, message } from 'antd';

const { TextArea } = Input;
const InputGroup = Input.Group;

class AcademicActionPlan extends React.Component {

    state = {
        currentStatus: null
    }

    //Using the submit and finalize button OR submit and come back button to make axios call.  Decide by R status type
    handleSubmit = (type) => {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                console.log(err)
            }
            const typeToStatus = {
                Status: (type === 'Finalize') ? "R" : ""
            }

            const submitData = Object.assign({}, values, typeToStatus)
            if (err && (type === 'Finalize')) {
                return stickyError('Please enter in all fields.');
            } else {
                axios.post(apiPath + '/admissions/addActionPlan', submitData, { withCredentials: true }).then(result => {
                    this.getActionPlan();
                }).then(result => {
                    this.props.isSubmitted();
                    message.success('Saved!');
                }).catch(error => {
                    this.props.isSubmitted();
                    this.props.handleAxiosSaveError(error);
                });
            }
        })
    }

    //enabling action plan status on click on status button changes("approved", "incomplete")
    updateStatus = (e) => {
        axios.post(apiPath + '/admissions/enableActionPlanStatus', { status: e.target.value }, { withCredentials: true }).then(result => {
            this.setState({ currentStatus: e.target.value })
        })
    }

    //get action plan to display status and answers if user has already completed part of the form
    getActionPlan = () => {
        axios.get(apiPath + '/admissions/getActionPlan', { withCredentials: true }).then(result => {
            this.setState({ currentStatus: result.data.Status })
            this.props.form.setFieldsValue({
                answer1: result.data.Answer1,
                answer2: result.data.Answer2,
                answer3: result.data.Answer3,
                answer4: result.data.Answer4,
                answer5: result.data.Answer5,
                answer6: result.data.Answer6,
                answer7: result.data.Answer7,
                answer8: result.data.Answer8,
                answer9: result.data.Answer9,
                signature: result.data.Signature,
                date: result.data.Date === null ? '' : moment.utc(result.data.Date.slice(0, 10))
            })
        })
    }

    componentDidMount() {
        this.getActionPlan();
    }

    render() {
        const { getFieldDecorator, isFieldTouched } = this.props.form;
        if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
            const redirect = this.props.redirectIfHidden(this.props, 'admissions/academic');
            if (redirect) return redirect;
        }

        return (
            <Form onSubmit={this.handleSubmit}>
                {this.props.variant === 'admin' &&
                    <Form.Item>
                        {getFieldDecorator('Status', {
                            initialValue: this.state.currentStatus
                        })(
                            <StatusRadioGroup disabled={this.props.variant !== 'admin'} onChange={this.updateStatus} />
                        )}
                    </Form.Item>
                }

                {this.props.variant !== 'admin' &&
                    <Form.Item>
                        {getFieldDecorator('Status', {
                        })(
                            <StandardSteps code={(this.state.currentStatus === null || this.state.currentStatus === undefined) ? "W" : this.state.currentStatus} />
                        )}
                    </Form.Item>

                }
                <br />
                <Card>
                    Thank you for your interest in the Semester at Sea program. The admission committee has reviewed your application and while we believe you are capable of being academically successful, there were still many concerns regarding your academic background. Therefore, we would like you to develop an Academic Action Plan for your upcoming voyage. Please take some time and effort and develop this plan with specific steps you intend to take in order to ensure your success on the voyage.
                    Semester at Sea is a demanding academic program, which will require your full commitment from the time the voyage commences. We want your academic efforts to be successful, so we urge you to choose your courses carefully, employ strong study habits, and maintain open communication with your professors. You will need to work very hard academically to be successful on your voyage. We believe  you are capable of obtaining high marks and being a positive contributor to your voyage, both in and outside of the classroom. We encourage you to seek out additional help as needed in order to be successful on your upcoming voyage.
            <br />
                    <br />
                    Please reference the pages below to assist you with completing your Academic Action Plan:
                <ul style={{ listStyleType: "disc", marginLeft: '20px', marginTop: '5px' }}>
                        <li><a href="https://www.semesteratsea.org/info-hub/student-life/#a-living-learning-community">Cocurricular Activities</a></li>
                        <li><a href="https://www.semesteratsea.org/info-hub/student-life/#organizations-and-activities">Extracurricular Activities</a></li>
                        <li><a href="https://www.semesteratsea.org/info-hub/student-life/#student-life-support">Student Support Staff</a></li>
                    </ul>
                    <br />
                    <Form.Item>
                        Please list your current class schedule (or tentative if you have not registered yet) for your voyage.
                        {getFieldDecorator('answer1', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        How do you plan to stay organized in your classes? (e.g. organizer, calendar, binder/notebook setup)
                        {getFieldDecorator('answer2', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        What resources you plan to utilize on the ship? (e.g cocurricular/extracurricular activities, Student Life Team)
                        {getFieldDecorator('answer3', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        How you plan to communicate with professors? (e.g. Initial meetings? Progress reports - Weekly? Bi-weekly?)
                        {getFieldDecorator('answer4', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        Discuss your current study habits and how you plan to improve them.
                        {getFieldDecorator('answer5', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        Outline a tentative daily study schedule (e.g. 2 – 4pm - Study Hours)
                        {getFieldDecorator('answer6', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        List which Field Programs you plan to register for each port. Please make sure you list your Field Classes.
                        {getFieldDecorator('answer7', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />

                    <Form.Item>
                        Identify what your current challenges are and areas where you know you will need additional support.
                        {getFieldDecorator('answer8', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />


                    <Form.Item>
                        What additional information do you feel is necessary to discuss in order for you to be successful on your voyage?
                        {getFieldDecorator('answer9', {
                            rules: [
                                { required: true, message: 'This field is required' },
                            ]
                        })(
                            <TextArea disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} rows={8} />
                        )}
                    </Form.Item>
                    <br />


                    <InputGroup compact>
                        <Form.Item>
                            {getFieldDecorator('signature', {
                                rules: [
                                    { required: true, message: 'This field is required' },
                                ]
                            })(
                                <Input disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} style={{ width: '80%', marginRight: '300px' }} placeholder="Electronic Signature" />
                            )}
                        </ Form.Item>
                        <Form.Item>
                            {getFieldDecorator('date', {
                                rules: [
                                    { required: true, message: 'This field is required' },
                                ]
                            })(
                                <DatePicker disabled={this.state.currentStatus === 'R' || this.state.currentStatus === 'A'} />
                            )}
                        </ Form.Item>
                    </InputGroup>
                    <Form.Item style={(this.props.style != null) ? this.props.style : { textAlign: 'right' }} {...this.props.formItemLayout}>
                        <Button
                            type="primary"
                            onClick={() => this.handleSubmit('Progress')}
                            icon="save"
                            loading={this.props.getStatus().submitting}
                            disabled={this.props.disabled || this.props.variant === 'admin' || this.state.currentStatus === "R"}>
                            {this.props.buttonText || 'Save Progress and Come Back'}
                        </Button>
                    </Form.Item>
                    <Form.Item style={(this.props.style != null) ? this.props.style : { textAlign: 'right' }} {...this.props.formItemLayout}>
                        <Button
                            type="primary"
                            onClick={() => this.handleSubmit('Finalize')}
                            icon="save"
                            loading={this.props.getStatus().submitting}
                            disabled={(this.props.disabled || this.props.variant === 'admin') || !this.props.form.isFieldsTouched()}>
                            {this.props.buttonText || 'Submit and Finalize'}
                        </Button>
                    </Form.Item>
                </Card>
            </Form>
        );
    }
}

export default withSpin(Form.create()(AcademicActionPlan));


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/AcademicActionPlan.jsx